<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-17 14:20:40
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-24 14:21:55
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/search/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="commercial-search">
		<!--搜索框-->
		<search-box ref="search" @change="onSearch"/>
		<!--商品类目-->
		<goods-category :platformId="platformId" ref="category" class="mt-24" @change="onCategory" />
		<!--带货数据-->
		<shipment-data :search-params="search" ref="shipment" class="mt-12" @change="onShipment" />
		<!--已选标签-->
		<selected-tag ref="selectdTag" @change="onDelete" @clear="onClear()"/>
		<!--商品列表排序-->
		<goods-filter :platformId="platformId" ref="goodsFilter" @change="onFilter"></goods-filter>
	</div>
</template>
<script>
import searchBox from './searchBox.vue';
import goodsCategory from './goodCategory.vue';
import shipmentData from './shipmentData.vue';
import selectedTag from './selectedTag.vue';
import goodsFilter from './goodsFilter.vue';
export default {
	props: {
		platformId: {
			type: Number,
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	components: {
		searchBox,
		goodsCategory,
		shipmentData,
		selectedTag,
		goodsFilter,
	},
	data() {
		return {
			search: {
				cateId: [],
				auditStatus:"0",
				outerProductName: '',
				commissionRate: '',
				commissionType: 0,
				shopScore: '',
				serviceFeeRate: '',
				talentCommission: '',
				sortField: 'orderNum',
				sortType: 'desc',
			},
			categoryArr: [],
			shipmentArr: [],
			shipmentMaps: newDataMap.SHOP_MANAGE.SHIPMENT_DATA,
			selectdArr: [],
			searchTagValue: '',
			refreshKey: false,
		};
	},
	computed:{
		selectCateId(){
			return this.search.cateId.length && this.search.cateId.map(val => val.category_id);
		}
	},
	methods: {
		/**
		 * 搜索框回调
		 * @param {*} obj
		 */
		onSearch(obj,type) {
			const { selectType, value } = obj;
			this.search.productId = '';
			this.search.outerProductName = '';
			this.search.outerShopName = '';
			this.search.institutionName = '';
			this.searchTagValue = value;
			this.search[selectType] = value;
			type && this.showTags()
		},
		/**	 
		 * 标签回显
		 */
		showTags() {
			if (this.$refs.selectdTag) {
				this.selectdArr = [
					{ name: '搜索',item: this.searchTagValue,type: 'search'},
					{ name: '商品类目', item: [...this.search.cateId], type: 'category' },
					{ name: '', type: 'shipment', item: [...this.shipmentArr] },
				];
				this.$refs.selectdTag.show(this.selectdArr);
				this.$emit('refresh', {...this.search,cateId: this.selectCateId || []});
			}
		},
		/**
		 * 商品类目回调
		 */
		onCategory(list) {
			this.search.cateId = list;
			this.showTags();
		},

		/**
		 * 带货数据回调
		 */
		onShipment(obj) {
			this.shipmentArr = [];
			for (var i in obj) {
				this.shipmentArr.push({
					name: this.shipmentMaps.get(i),
					key: i,
					value: obj[i],
					label: this.shipmentMaps.get(obj[i]) || '',
				});
			}
			this.search = {...this.search,...obj};
			this.showTags();
		},
		/**
		 * 商品列表头部筛选
		 */
		onFilter(type){
			this.search.sortField = type;
			this.showTags();
		},
		/**
		 * 标签删除
		 */
		onDelete(obj) {
			const { type, item } = obj;
			let refsMaps = new Map([[0,'search'],[1,'category'],[2,'shipment']]);
			this.$refs[refsMaps.get(type)].onClear(type === 2 ? item.key : '')
		},
		/**
		 * 清空选项
		 */
		onClear(){
			this.$emit('clear')
		},
	},
};
</script>
<style lang="less" scoped>
.commercial-search {
	width: 100%;
}
</style>
